import cn from 'classnames';
import Select from 'components/Select';
import { i18nPath } from 'config/i18nNs';
import { Col, Row } from 'layout/Grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './employer.module.scss';

interface EmployerSelectProps {
  countriesList: Array<{ value: string; label: string }>;
  employersList?: Array<{ value: string; label: string }>;
  selectedCountry: { value: string; label: string };
  selectedEmployer: { value: string; label: string };
  handleChangeCountry: (event: any) => void;
  handleChangeEmpl: (event: any) => void;
  employersDisabled: boolean;
  submitDisabled: boolean;
  handleSubmit: (event: any) => void;
}

const EmployerSelect: React.FC<EmployerSelectProps> = ({
  countriesList,
  selectedCountry,
  handleChangeCountry,
  employersDisabled,
  selectedEmployer,
  handleChangeEmpl,
  employersList,
  submitDisabled,
  handleSubmit
}) => {
  const { t } = useTranslation();
  const sortOptions = (options: Array<{ value: string; label: string }>) =>
    options.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Row className={styles.root}>
      <Col sm={12} md={4}>
        <label htmlFor="countries">
          <p className={styles.label}>
            1. {t(`${i18nPath.dictionary}.selectCountry`)}
          </p>
        </label>

        <Select
          value={selectedCountry}
          options={sortOptions(countriesList)}
          onChange={handleChangeCountry}
        />
      </Col>
      <Col sm={0} md={1} />

      <Col sm={12} md={4} className={styles.block}>
        <label htmlFor="employers">
          <p className={cn(styles.label, employersDisabled && styles.disabled)}>
            2. {t(`${i18nPath.dictionary}.selectEmployerName`)}
          </p>
        </label>

        <Select
          disabled={employersDisabled}
          value={selectedEmployer}
          options={sortOptions(employersList)}
          onChange={handleChangeEmpl}
        />
      </Col>

      <Col sm={0} md={1} />

      <Col sm={12} md={2} className={styles.buttonWrapper}>
        <button
          className={styles.button}
          type="button"
          disabled={submitDisabled}
          onClick={handleSubmit}
        >
          {t(`${i18nPath.dictionary}.go`)}
        </button>
      </Col>
    </Row>
  );
};

export default EmployerSelect;
